import React from 'react';
import docSpaceIcon from '@/assets/mindIcon/doc-space.svg';
import projectIcon from '@/assets/mindIcon/project.svg';
import folderIcon from '@/assets/mindIcon/folder.svg';
import docIcon from '@/assets/mindIcon/doc.svg';
import fileIcon from '@/assets/mindIcon/file.svg';
import type { MindNodeType } from '@/utils/mindHost';

const MIND_NODE_ICON_URL: Record<MindNodeType, string> = {
  doc_space: docSpaceIcon,
  project: projectIcon,
  folder: folderIcon,
  doc: docIcon,
  file: fileIcon,
};

export function mindNodeIconMask(type: MindNodeType): string {
  return `url(${JSON.stringify(MIND_NODE_ICON_URL[type])})`;
}

export function MindNodeIcon({ type }: { type: MindNodeType }): React.ReactElement {
  const mask = mindNodeIconMask(type);
  return (
    <span
      className="mind-node-icon"
      style={{ maskImage: mask, WebkitMaskImage: mask }}
      aria-hidden
    />
  );
}
